// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__6JH6t","active":"IconButton_active__5DHXq","loading":"IconButton_loading__LFOO6"};